const BLOCKED_REASONS = new Set([null, 'runtime_not_ready', 'no_eligible_testers', 'captcha_not_ready', 'unsupported_environment']);

export function canManageRegistrationSettings(platform) {
  return platform?.admin === true
    && Array.isArray(platform.capabilities)
    && platform.capabilities.includes('platform.companies.manage');
}

function invalidSettings() {
  return Object.assign(new Error('Registration settings are unavailable.'), { code: 'invalid_registration_settings_response' });
}

export function checkedRegistrationSettings(value) {
  if (!value || typeof value.enabled !== 'boolean' || typeof value.effectiveEnabled !== 'boolean'
    || typeof value.canEnable !== 'boolean' || !['staging_allowlist', 'staging_public', 'production_public'].includes(value.scope)
    || typeof value.captchaRequired !== 'boolean' || typeof value.captchaReady !== 'boolean'
    || !Number.isSafeInteger(value.revision) || value.revision < 0
    || !BLOCKED_REASONS.has(value.blockedReason)
    || value.canEnable !== (value.blockedReason === null)
    || (value.canEnable && value.captchaRequired && !value.captchaReady)
    || (value.blockedReason === 'captcha_not_ready' && (!value.captchaRequired || value.captchaReady))
    || value.effectiveEnabled !== (value.enabled && value.canEnable)
    || (value.blockedReason === 'unsupported_environment' ? value.enabled || value.revision !== 0 : value.revision < 1)) throw invalidSettings();
  return {
    enabled: value.enabled, effectiveEnabled: value.effectiveEnabled,
    canEnable: value.canEnable, revision: value.revision,
    scope: value.scope, blockedReason: value.blockedReason,
    captchaRequired: value.captchaRequired, captchaReady: value.captchaReady,
  };
}

export function registrationSettingsBody({ enabled, captchaRequired, expectedRevision } = {}) {
  if (typeof enabled !== 'boolean' || typeof captchaRequired !== 'boolean' || !Number.isSafeInteger(expectedRevision) || expectedRevision < 0) throw invalidSettings();
  return { enabled, captchaRequired, expectedRevision };
}

export function checkedRegistrationSettingsSave(value, request) {
  const next = checkedRegistrationSettings(value);
  if (next.enabled !== request.enabled || next.captchaRequired !== request.captchaRequired || next.revision <= request.expectedRevision) throw invalidSettings();
  return next;
}

export function registrationDraftBlockedReason(snapshot, captchaRequired) {
  if (!snapshot) return 'unsupported_environment';
  // A draft CAPTCHA change cannot bypass an independent runtime/admission blocker.
  if (snapshot.blockedReason && snapshot.blockedReason !== 'captcha_not_ready') return snapshot.blockedReason;
  return captchaRequired && !snapshot.captchaReady ? 'captcha_not_ready' : null;
}

export function canSaveRegistrationSettings(snapshot, enabled, captchaRequired) {
  return Boolean(snapshot && snapshot.blockedReason !== 'unsupported_environment'
    && (enabled !== snapshot.enabled || captchaRequired !== snapshot.captchaRequired)
    && (!enabled || registrationDraftBlockedReason(snapshot, captchaRequired) === null));
}

export function registrationReadinessMessage(reason) {
  return {
    runtime_not_ready: 'Registration cannot be enabled until environment setup is ready.',
    no_eligible_testers: 'No approved users are currently eligible to register.',
    captcha_not_ready: 'CAPTCHA is not configured. Complete setup or turn off the CAPTCHA requirement before enabling registration.',
    unsupported_environment: 'Registration settings are unavailable in this environment.',
  }[reason] || '';
}
